import { customIdSchema, isId } from './ids'
import type z from 'zod'

const CustomIconIdSchema = customIdSchema('ICON', ':')
export type CustomIconId = z.infer<typeof CustomIconIdSchema>
export const isCustomIconId = isId(CustomIconIdSchema)
export const COMPANY_ICON_ID: CustomIconId = 'ICON:COMPANY'
